// extracted by mini-css-extract-plugin
export default {"cardQuickTip":"QuickTipCard_cardQuickTip__RvuKb"};